import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import koLocale from 'date-fns/locale/ko';
import enLocale from 'date-fns/locale/en-US';
import { BrowserRouter as Router } from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { IntlProvider } from 'react-intl';
import { SnackbarProvider } from 'notistack';
import userIntlLocale from 'hooks/useIntlLocale';
import genrateTheme from 'styles/theme';

interface ProviderProps {
  children: React.ReactChild;
}

const localeMap = {
  en: enLocale,
  ko: koLocale
};

const Provider: React.FC<ProviderProps> = ({ children }) => {
  const { locale, messages } = userIntlLocale();
  return (
    <IntlProvider
      messages={messages}
      locale={locale}
      key={locale}
      defaultLocale="ko"
    >
      <MuiPickersUtilsProvider
        // @ts-ignore
        locale={localeMap[locale]}
        utils={DateFnsUtils}
      >
        {(locale === 'ko' || messages) && (
          <ThemeProvider theme={genrateTheme(locale)}>
            <SnackbarProvider
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'center'
              }}
              maxSnack={3}
            >
              <CssBaseline />
              <Router>{children}</Router>
            </SnackbarProvider>
          </ThemeProvider>
        )}
      </MuiPickersUtilsProvider>
    </IntlProvider>
  );
};

export default Provider;
